import { useIsAutoCegidIntegrationEnabled } from './useIsAutoCegidIntegrationEnabled'

export const useOrgUsesReceiptsOnly = () => {
  const { isAutoCegidIntegrationEnabled } = useIsAutoCegidIntegrationEnabled()

  return isAutoCegidIntegrationEnabled
}
